import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { DEBOUNCE_TIME } from '~/constants/main';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { SearchInput } from '~/view/components/Controls/Inputs';
import { messageCampaignListStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/store/messageCampaignListStore';
import './style.scss';

const MessageCampaignListHeader = observer(() => {
  const handleSearch = (value: string | undefined) => {
    messageCampaignListStore.setFilters({ search: value || '' });
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <SearchInput
        value={messageCampaignListStore.filters.search}
        onChangeValue={handleSearch}
        loading={messageCampaignListStore.loading}
        debounceDelay={DEBOUNCE_TIME.MEDIUM}
        placeholder="txt_search"
        className="campaigns-header__search-input"
        inputClassName="px-3 color-dark text-size-16 family-medium"
      />
      <Link to={SCREENS.MESSAGE_CAMPAIGN_CREATE()}>
        <Button title={localeStore.t('marketing_mc_create_message_btn')} loading={messageCampaignListStore.loading} />
      </Link>
    </div>
  );
});

export default MessageCampaignListHeader;
